import { formatMoneyCurrency } from '@/shared/utils/formatMoneyDisplay';

export function negativeBalanceWarning(fundBalance: string): string {
    const shortfall = formatMoneyCurrency(fundBalance.trim().replace(/^-/, ''));
    return `This customer has used ${shortfall} more servicing than they have paid for. Take a top-up for the shortfall before cancelling, or your dealership will cover it.`;
}
